import React, { useState } from 'react';
import { Route } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import 'moment';
import 'moment/locale/de';

import { useMediaQuery, Grid } from '@material-ui/core';

import Bar from './bar';
import FilterContainer from './filter-container';
import LocationContainer from './location-container';
import { StateToUrl, MessageBox, NoteDialog } from '../components';

import config from '../../run-config';

function Main(props) {
  const [isOpen, setIsOpen] = useState(true);
  const useDesktopLayout = useMediaQuery('(min-width:600px)');

  const {
    inApp, messages, removeMessageByIndex, setUseDesktopLayout,
  } = props;
  setUseDesktopLayout(useDesktopLayout);


  const drawerStateOpen = isOpen && !inApp;

  return (
    <div className={inApp ? 'inapp App' : 'App'}>
      {!inApp && (
        <Bar filtersOpen={isOpen} toggleFiltersOpen={() => setIsOpen(!isOpen)} />
      )}
      <Grid container spacing={0}>
        {inApp
          ? null
          : (
            <Route
            path="/:filters?"
            render={componentProps => (
              <Grid item xs={12} sm={5} md={4} lg={3}>
                <FilterContainer
                  {...componentProps}
                  isOpen={drawerStateOpen}
                  useDesktopLayout={useDesktopLayout}
                />
              </Grid>
            )}
          />)
        }
        <Grid item xs={12} sm={drawerStateOpen ? 7 : 12} md={drawerStateOpen ? 8 : 12} lg={drawerStateOpen ? 9 : 12}>
          { config.notesFeature === 'true'
          && <NoteDialog useDesktopLayout={useDesktopLayout} />
          }
          <MessageBox messages={messages} useDesktopLayout={useDesktopLayout} removeMessageByIndex={removeMessageByIndex} />
          <LocationContainer inApp={inApp} filtersOpen={drawerStateOpen} useDesktopLayout={useDesktopLayout} />
        </Grid>
      </Grid>
      <Route path="/" component={StateToUrl} />
    </div>
  );
}

Main.propTypes = {
  inApp: PropTypes.bool,
  messages: PropTypes.array,
  removeMessageByIndex: PropTypes.func.isRequired,
  setUseDesktopLayout: PropTypes.func.isRequired,
};

Main.defaultProps = {
  inApp: false,
  messages: [],
};


export default Main;
